module.exports = __webpack_public_path__ + "img/ceo_way_adv_02.5e6f4511.png";